module.exports = __webpack_public_path__ + "static/img/basicnew1.a24be1f9.png";